import { type RouteRecordRaw } from "vue-router";

import { APP_ROUTES } from "@/Generated/Routes/paths";

export default [
  {
    path: APP_ROUTES.error.root.path,
    component: () => import("@/Components/layout/ErrorLayout.vue"),
    children: [
      {
        ...APP_ROUTES.error[404].root,
        component: () => import("@/Views/errors/404.vue"),
        meta: {
          isPublic: true,
        },
      },
      {
        ...APP_ROUTES.error.offline.root,
        component: () => import("@/Views/errors/Offline.vue"),
        meta: {
          isPublic: true,
        },
      },
    ],
  },
  { path: "/:catchAll(.*)", redirect: { name: APP_ROUTES.error[404].root.name } },
] as RouteRecordRaw[];
